import { useAppSelector } from 'app/store';
import { getAuthenticatedSelector } from 'app/store/Auth/selectors';
import React from 'react';
import { SignInRedirect } from 'app/views/SignInRedirect';
import { Navigate, useLocation } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';

export const Auth = () => {
  const location = useLocation();
  const isAuthenticated = useAppSelector(getAuthenticatedSelector);

  return isAuthenticated ? (
    <SignInRedirect />
  ) : (
    <Navigate
      to={{ pathname: routes.signIn.route, search: location.search }}
      state={location.state}
      replace
    />
  );
};
